import { ModalComponent } from '../../lib/services/modal.service';
import { Component, HostListener } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import {
  ImageService,
  UploadImageResponse,
} from '../../lib/services/imageService';
import { delay, startWith, take } from 'rxjs/operators';
import { Ng2ImgMaxService } from 'ng2-img-max';
import * as layout from '../../core/actions/layout';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { Observable } from 'rxjs';

export class UploadImageModel {
  // pass image ratio as array
  constructor(public type: UploadImageType, public ratio: Array<number>) {}
}

export enum UploadImageType {
  PROFILE_PICTURE_TYPE = 0,
  JOB_TYPE = 1,
  UNIT_LOGO_TYPE = 2,
  LISTING_IMAGE_TYPE = 3,
}

@Component({
  selector: 'mj-upload-image-modal',
  templateUrl: './upload-image-modal.component.html',
  styleUrls: ['./upload-image-modal.component.scss'],
})
export class UploadImageModalComponent extends ModalComponent {
  imageChangedEvent: any = '';
  croppedImage: any = '';

  dragging: boolean;

  imageType: UploadImageType;
  imageRatio: Array<number>;
  loading$: Observable<any>;

  constructor(
    private store: Store<fromRoot.State>,
    private imageService: ImageService,
    private _ng2ImgMax: Ng2ImgMaxService
  ) {
    super();

    this.data.pipe(take(1)).subscribe((data: UploadImageModel) => {
      this.imageType = data.type;
      this.imageRatio = data.ratio;
    });

    this.loading$ = this.store.select(fromRoot.getProgressBarStatus).pipe(
      startWith(null),
      delay(0)
    );
  }

  @HostListener('dragover') onDragOver() {
    return false;
  }

  @HostListener('dragenter') handleDragEnter() {
    this.dragging = true;
  }

  @HostListener('dragleave') handleDragLeave() {
    this.dragging = false;
  }

  @HostListener('drop', ['$event']) handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleDropFile(e);
  }

  closeModal() {
    this.resolve.next(null);
  }

  fileChangeEvent(e: any): void {
    const file = e.target ? e.target.files[0] : 'null';

    const pattern = /image-*/;

    if (!file['type'].match(pattern)) {
      alert('invalid format');
      return;
    }

    this._ng2ImgMax.compressImage(file, 1).subscribe(
      (resizedFile: File) => {
        this.imageChangedEvent = {
          target: {
            files: [resizedFile],
          },
        };
      },
      error => {
        this.imageChangedEvent = {
          target: {
            files: [file],
          },
        };
      }
    );
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event;
  }

  handleDropFile(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : 'null';

    const pattern = /image-*/;

    if (!file['type'].match(pattern)) {
      alert('invalid format');
      return;
    }

    this._ng2ImgMax.compressImage(file, 1).subscribe(
      (resizedFile: File) => {
        this.imageChangedEvent = {
          target: {
            files: [resizedFile],
          },
        };
      },
      error => {
        this.imageChangedEvent = {
          target: {
            files: [file],
          },
        };
      }
    );
  }

  clearImage() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
  }

  saveImage() {
    const formData = new FormData();
    formData.append('image', this.croppedImage.file, 'test.png');
    formData.append('type', this.imageType.toString());
    this.imageService
      .uploadImage(formData)
      .pipe(take(1))
      .subscribe((data: UploadImageResponse) => {
        if (data) {
          this.resolve.next({
            id: data.id,
            image: data.image,
            image_thumbnail: data.image_thumbnail,
          });
        }
      });
  }

  onUploadFile(uploadFile: HTMLInputElement) {
    uploadFile.click();
  }
}
